import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/CustomFormList/index.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "order-GeneraVisit"
  }, [_c('view-box', {
    ref: "viewBox"
  }, [_c('Group', [_c('Cell', {
    attrs: {
      "title": i18n.tc("315") + " ",
      "value": i18n.tc("316"),
      "is-link": ""
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.handleJump.apply(null, arguments);
      }
    }
  })], 1), _c(__unplugin_components_0, {
    ref: "customFormList",
    attrs: {
      "data": _vm.fieldList
    },
    on: {
      "on-change": function ($event) {
        _vm.form.visitField = $event;
      }
    }
  }), _c('Group', [_c('Cell', {
    attrs: {
      "title": i18n.tc("317")
    }
  }, [_c('Rater', {
    attrs: {
      "value": _vm.form.satisfaction_state / 20
    },
    on: {
      "input": function ($event) {
        _vm.form.satisfaction_state = $event * 20;
      }
    }
  })], 1)], 1), !_vm.orderInfo.return_visit_state ? _c('div', {
    staticClass: "bottom-bar",
    attrs: {
      "slot": "bottom"
    },
    slot: "bottom"
  }, [_c('div', {
    staticClass: "bottom-btn-body"
  }, [_c('x-button', {
    staticClass: "no-border-radius",
    attrs: {
      "type": "primary",
      "show-loading": _vm.loading
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.handleSubmit.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + i18n.tc("318") + " ")])], 1)]) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };